import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DashboardLayout from "@/layouts/DashboardLayout";
import Header from "@/components/ui/header";
import Button from "@/components/ui/button";
import Toast from "@/components/ui/toast";
import styles from "./ComponentsPage.module.scss";

const ComponentsPage: React.FC = () => {
  const { t } = useTranslation();
  const [successToast, setSuccessToast] = useState(false);
  const [failToast, setFailToast] = useState(false);

  return (
    <DashboardLayout>
      <Header title={t("components.title")} />

      <div className={styles.pageContainer}>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t("components.toast.title")}
          </h2>
          <p className={styles.sectionDesc}>
            {t("components.toast.description")}
          </p>
          <div className={styles.actions}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setFailToast(false);
                setSuccessToast(true);
              }}
            >
              {t("components.toast.showSuccess")}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setSuccessToast(false);
                setFailToast(true);
              }}
            >
              {t("components.toast.showFail")}
            </Button>
          </div>

          <div className={styles.toastPreview}>
            {successToast && (
              <Toast
                variant="success"
                message={t("components.toast.successExample")}
                onClose={() => setSuccessToast(false)}
                duration={10000}
              />
            )}
            {failToast && (
              <Toast
                variant="fail"
                message={t("components.toast.failExample")}
                onClose={() => setFailToast(false)}
                duration={10000}
              />
            )}
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
};

export default ComponentsPage;
